import React, { FC, PropsWithChildren, ReactNode } from 'react';
import classnames from 'classnames';

import styles from './Cell.module.css';

interface CellProps {
    title: string;
    rightSection?: ReactNode;
    description?: ReactNode;
    withHover?: boolean;
    setCellRef?: (element?: Element | null | undefined) => void;
    className?: string;
}

export const Cell: FC<PropsWithChildren<CellProps>> = ({
    title,
    rightSection,
    children,
    description,
    withHover,
    setCellRef,
    className,
}) => (
    <div
        className={classnames(styles.root, className, { [styles.withHover]: withHover })}
        ref={setCellRef}
    >
        <div className={styles.leftSection}>
            <span className={styles.title}>{title}</span>
            {description && <span className={styles.description}>{description}</span>}
            {children && <div className={styles.innerSection}>{children}</div>}
        </div>
        {rightSection}
    </div>
);
